export default __webpack_public_path__ + "static/media/arrow_right.af38fe31.svg";